"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var amber = {
  50: '#ffefd6',
  100: '#fddfb6',
  200: '#f9c684',
  300: '#f3ad59',
  400: '#eb9437',
  500: '#e07c1e',
  600: '#d1620d',
  700: '#be4902',
  800: '#a83600',
  900: '#912700',
  A100: '#fff7eb',
  A200: '#fec363',
  A400: '#feb927',
  A700: '#d7720d'
};
exports["default"] = amber;